import { ExercisePlanTable } from "@/components/exercise-plans/exercise-plan-table"

export default function ExercisePlansPage() {
  return (
    <>
      <div className="mb-8">
        <h1 className="text-3xl font-bold">Exercise Plans</h1>
        <p className="text-muted-foreground">Create and manage exercise plans for your clients</p>
      </div>
      <ExercisePlanTable />
    </>
  )
}
